import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServiceSelector from './components/ServiceSelector';
import HowItWorks from './components/HowItWorks';
import FeatureBlock from './components/FeatureBlock';
import RepairsSection from './components/RepairsSection';
import SocialProof from './components/SocialProof';
import CoverageSection from './components/CoverageSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import SiteWidgets from '../../components/feature/SiteWidgets';

export default function Home() {
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowFloating(window.scrollY > 500);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToQuote = () =>
    document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <main className="min-h-screen bg-white font-sans">
      <Header />
      <HeroSection />
      <TrustBar />
      <ServiceSelector />
      <HowItWorks />
      <SocialProof />
      <CoverageSection />
      <FeatureBlock />
      <RepairsSection />
      <CTASection />
      <Footer />
      <SiteWidgets />

      {/* Floating CTA — desktop */}
      <div
        className={`fixed bottom-6 right-6 z-40 hidden md:block transition-all duration-300 ${
          showFloating ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <button
          onClick={scrollToQuote}
          className="bg-gradient-to-r from-[#4CAF50] to-[#7AC943] text-white font-bold px-5 py-3 rounded-full text-sm hover:opacity-90 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill text-sm" />
          </div>
          Get My Fixed Price
        </button>
      </div>

      {/* Sticky mobile CTA bar */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-40 md:hidden transition-all duration-300 ${
          showFloating ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="bg-white border-t border-gray-200 px-4 py-3 flex items-center gap-2">
          <button
            onClick={() => window.dispatchEvent(new CustomEvent('openBooking'))}
            className="flex items-center gap-1.5 border-2 border-[#145A32] text-[#145A32] font-bold px-3.5 py-2.5 rounded-full text-xs cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-xs" />
            </div>
            Book
          </button>
          <button
            onClick={scrollToQuote}
            className="flex-1 bg-gradient-to-r from-[#145A32] to-[#4CAF50] text-white font-bold px-4 py-2.5 rounded-full text-sm hover:opacity-90 cursor-pointer whitespace-nowrap"
          >
            Get your fixed price →
          </button>
        </div>
      </div>
    </main>
  );
}
